import { render, staticRenderFns } from "./PhoneThanks.vue?vue&type=template&id=757254e4&scoped=true&"
import script from "./PhoneThanks.vue?vue&type=script&lang=js&"
export * from "./PhoneThanks.vue?vue&type=script&lang=js&"
import style0 from "./PhoneThanks.vue?vue&type=style&index=0&id=757254e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757254e4",
  null
  
)

export default component.exports